import { StudioSearchBox } from './StudioSearchBox'

export default StudioSearchBox
